import * as icons from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { backTarget } from "../utils/helper/navigation";

/**
 * The arrow at the top left of the sign-in and sign-up pages (#278). A button, so Tab reaches it
 * (it was a bare svg with a click handler). Without `onClick` it goes back to the previous page,
 * or to `fallback` when the page was opened directly.
 *
 * @param {object} props
 * @param {() => void} [props.onClick] Replaces going back, e.g. closing a notice shown in place.
 * @param {string} [props.fallback]
 */
export const BackButton = ({ onClick, fallback = "/Home" }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="back-button"
      aria-label="Back"
      onClick={onClick ?? (() => navigate(backTarget(window.history.state, fallback)))}
    >
      <icons.ArrowLeft />
    </button>
  );
};
